<template>
  <div
    id="by_function"
    style="height:400px;background-color: #fff;padding: 15px;"
  ></div>
</template>

<script>
import { getSubRunningChart } from "@/api/analysis";
import { mapState } from "vuex";

export default {
  name: "FunctionRunningChart",
  props: {
    chartFunctionParams: Object
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("by_function"));
      let option = {};
      let chartData = [];

      getSubRunningChart({
        userID: this.accountInfo.userID,
        ...this.chartFunctionParams
      }).then(response => {
        if (response.data.chart) {
          chartData = response.data.chart;
        }

        option = {
          title: {
            text: "By Function",
            left: "center",
            top: 20,
            textStyle: {
              color: "#ccc"
            }
          },

          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: [
            {
              name: "Function",
              type: "pie",
              radius: "55%",
              center: ["50%", "50%"],
              data: chartData.sort(function(a, b) {
                return a.value - b.value;
              }),
              roseType: "radius",
              label: {
                color: "#999"
              },
              labelLine: {
                lineStyle: {
                  color: "#999"
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              },
              itemStyle: {
                color: "#67C23A",
                shadowBlur: 200,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },

              animationType: "scale",
              animationEasing: "elasticOut"
            }
          ]
        };
        myChart.setOption(option);
      });
    }
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  watch: {
    chartFunctionParams: function() {
      this.drawChart();
    }
  }
};
</script>
